export const reducerTypes = {
    GET_ALL_COLLECTIONS: "reducer/GET_ALL_COLLECTIONS",
    GET_COLLECTION: "reducer/GET_COLLECTION",
    GET_PAGE_INFO: "reducer/GET_PAGE_INFO",
    IS_LOADING: "reducer/LOADING_TRUE",
  };
  
  export const sagaTypes = {
    GET_ALL_COLLECTIONS: "saga/GET_ALL_COLLECTIONS",
    GET_COLLECTION: "saga/GET_COLLECTION",
    IS_LOADING: "saga/LOADING_TRUE",
  };
  